<!--
 * @Description: 代理管理主入口
 * @Author: gao shuai
 * @Date: 2020-06-13 11:32:01
 * @LastEditTime: 2020-08-17 14:59:48
 * @LastEditors: gao shuai
-->
<template>
  <div class="main">
    <div class="header">
      <div class="headbox clearfix">
        <!--<div class="logo"><img src="../../assets/images/logo.png" alt=""></div>-->
        <ul class="navbox clearfix">
          <li>
            <span class="icon1" @click="refresh('/main/home')">首页</span>
          </li>
          <li>
            <span class="icon1" @click="refresh('/main/Ordermanagement')">订单管理</span>
          </li>
          <li>
            <span class="icon1" @click="refresh('/main/Zoningmanagement')">分区管理</span>
          </li>
          <li>
            <span class="icon1" @click="refresh('/main/DA')">数据分析</span>
          </li>
          <li>
            <span class="icon1" @click="refresh('/personal')">个人中心</span>
          </li>
          <li v-if="userType">
            <span class="icon1" @click="refresh('/agentsystem')">代理系统</span>
          </li>
        </ul>
        <div class="count">{{nickName}}</div>
      </div>
    </div>
    <div class="container">
      <div class="midleContaner">
        <div class="slider">
          <div class="top_tit">代理管理</div>
          <ul>
            <li>
              <span class="icon1" @click="refresh('/agentsystem/merchant')">下属商户</span>
            </li>
            <li>
              <span class="icon2" @click="refresh('/agentsystem/agentOrder')">代理订单</span>
            </li>
            <li>
              <span class="icon3" @click="refresh('/agentsystem/userGroup')">用户分组</span>
            </li>
            <li>
              <span class="icon4" @click="refresh('/agentsystem/Statistics')">数据统计</span>
            </li>
            <li>
              <span class="icon5" @click="refresh('/agentsystem/agentManagement')">分区管理</span>
            </li>
          </ul>
        </div>
        <div class="contentbox">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'agentSystem',
  inject: ['reload'],
  data() {
    return {};
  },
  computed: {
    ...mapState(['userType', 'nickName'])
  },
  methods: {
    // 获取用户信息
    getUser() {
      this.$api.home
        .getUserinfo()
        .then((data) => {
          this.$store.commit('saveuuid', data.data.uuid);
          this.$store.commit('saveType', data.data.type);
          this.$store.commit('changeNickName', data.data.userName);
          this.$store.commit('changeId', data.data.id);
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 跳转路由刷新
    refresh(path) {
      if (this.$route.path.indexOf(path) > -1) {
        this.reload();
      } else {
        this.$router.push({ path: path });
      }
    }
  },
  created() {
    this.getUser();
  }
};
</script>

<style lang="scss" scoped>
.main {
  position: relative;
  padding-top: 60px;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background: #e6edf5;
  .header {
    position: absolute;
    width: 100%;
    height: 60px;
    top: 0;
    left: 0;
    background: #63aafa;
    .headbox {
      width: 80vw;
      margin: 0 auto;
      height: 60px;
      .logo {
        margin-top: 13px;
        float: left;
      }
      .navbox {
        float: left;
        margin-top: 15px;
        margin-left: 50px;
        li {
          float: left;
          padding: 0 35px;
          height: 28px;
          line-height: 28px;
          border-right: 1px solid #fff;
          color: #fff;
          font-size: 16px;
          span {
            cursor: pointer;
          }
        }
      }
      .count {
        float: right;
        height: 28px;
        line-height: 28px;
        padding: 0 20px;
        margin-right: 30px;
        font-size: 19px;
        color: #fff;
        margin-top: 15px;
      }
    }
  }
  .container {
    height: 100%;
    box-sizing: border-box;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5);
    }
    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5);
      border-radius: 10px;
    }
    .midleContaner {
      width: 80vw;
      margin: 20px auto 22px;
      position: relative;
      // box-shadow: 0 0 10px rgba(0, 0, 0, .25);
      .slider {
        position: absolute;
        width: 160px;
        background: #343434;
        height: 100%;
        left: 0;
        top: 0;
        .top_tit {
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-size: 16px;
          font-weight: bold;
          color: #63aafa;
          background: #fff url(../../assets/images/line_big.png) no-repeat 0
            center;
        }
        ul {
          margin-top: 30px;
          li {
            height: 35px;
            line-height: 35px;
            margin-bottom: 10px;
            color: #fff;
            font-size: 14px;
            span {
              display: block;
              cursor: pointer;
              height: 35px;
              padding-left: 66px;
              &.icon1 {
                background: url(../../assets/images/agent_1.png) no-repeat 39px
                  center;
                background-size: auto 24px;
              }
              &.icon2 {
                background: url(../../assets/images/agent_2.png) no-repeat 39px
                  center;
                background-size: auto 23px;
              }
              &.icon3 {
                background: url(../../assets/images/agent_3.png) no-repeat 40px
                  center;
                background-size: auto 22px;
              }
              &.icon4 {
                background: url(../../assets/images/agent_4.png) no-repeat 39px
                  center;
                background-size: auto 24px;
              }
              &.icon5 {
                background: url(../../assets/images/agent_5.png) no-repeat 40px
                  center;
                background-size: auto 20px;
              }
            }
          }
        }
      }
      .contentbox {
        min-height: 800px;
        margin-left: 178px;
      }
    }
  }
  .areaContainer {
    padding: 0 0 20px 15px;
    li {
      position: relative;
      float: left;
      border: 1px solid #ddd;
      padding: 4px;
      cursor: pointer;
      margin-right: 17px;
      .imgbox {
        padding: 15px 8px;
      }
      .mask {
        display: none;
        position: absolute;
        top: 4px;
        left: 4px;
        width: 112px;
        height: 90px;
        background: rgba(0, 0, 0, 0.7);
        color: #fff;
        text-align: center;
        line-height: 90px;
      }
      &:hover {
        border-color: #00b066;
        .mask {
          display: block;
        }
      }
      img {
        display: block;
      }
    }
  }
}
</style>
